"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/app/front/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/app/front/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/app/front/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/app/front/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/app/front/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Generator_1 = require("./Generator");
/* tslint:disable:variable-name */


var ExplorerActionGenerator = /*#__PURE__*/function (_Generator_1$ActionGe) {
  _inherits(ExplorerActionGenerator, _Generator_1$ActionGe);

  var _super = _createSuper(ExplorerActionGenerator);

  function ExplorerActionGenerator(contract, api) {
    var _this;

    _classCallCheck(this, ExplorerActionGenerator);

    _this = _super.call(this, contract);
    _this.api = api;
    _this.config = api.getConfig();
    return _this;
  }

  _createClass(ExplorerActionGenerator, [{
    key: "createcol",
    value: function () {
      var _createcol = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(authorization, author, collection_name, allow_notify, authorized_accounts, notify_accounts, market_fee, data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _get(_getPrototypeOf(ExplorerActionGenerator.prototype), "createcol", this);
                _context.t1 = this;
                _context.t2 = authorization;
                _context.t3 = author;
                _context.t4 = collection_name;
                _context.t5 = allow_notify;
                _context.t6 = authorized_accounts;
                _context.t7 = notify_accounts;
                _context.t8 = market_fee;
                _context.t9 = Generator_1;
                _context.t10 = data;
                _context.next = 13;
                return this.config;

              case 13:
                _context.t11 = _context.sent.collection_format;
                _context.t12 = _context.t9.toAttributeMap.call(_context.t9, _context.t10, _context.t11);
                return _context.abrupt("return", _context.t0.call.call(_context.t0, _context.t1, _context.t2, _context.t3, _context.t4, _context.t5, _context.t6, _context.t7, _context.t8, _context.t12));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createcol(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
        return _createcol.apply(this, arguments);
      }

      return createcol;
    }()
  }, {
    key: "createtempl",
    value: function () {
      var _createtempl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(authorization, authorized_creator, collection_name, schema_name, transferable, burnable, max_supply, immutable_data) {
        var schema, immutable_attribute_map;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.api.getSchema(collection_name, schema_name);

              case 2:
                schema = _context2.sent;
                immutable_attribute_map = Generator_1.toAttributeMap(immutable_data, schema.format);
                return _context2.abrupt("return", _get(_getPrototypeOf(ExplorerActionGenerator.prototype), "createtempl", this).call(this, authorization, authorized_creator, collection_name, schema_name, transferable, burnable, max_supply, immutable_attribute_map));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createtempl(_x9, _x10, _x11, _x12, _x13, _x14, _x15, _x16) {
        return _createtempl.apply(this, arguments);
      }

      return createtempl;
    }()
  }, {
    key: "mintasset",
    value: function () {
      var _mintasset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(authorization, authorized_minter, collection_name, schema_name, template_id, new_owner, immutable_data, mutable_data, tokens_to_back) {
        var schema, immutable_attribute_map, mutable_attribute_map;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.api.getSchema(collection_name, schema_name);

              case 2:
                schema = _context3.sent;
                immutable_attribute_map = Generator_1.toAttributeMap(immutable_data, schema.format);
                mutable_attribute_map = Generator_1.toAttributeMap(mutable_data, schema.format);
                return _context3.abrupt("return", _get(_getPrototypeOf(ExplorerActionGenerator.prototype), "mintasset", this).call(this, authorization, authorized_minter, collection_name, schema_name, template_id, new_owner, immutable_attribute_map, mutable_attribute_map, tokens_to_back));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function mintasset(_x17, _x18, _x19, _x20, _x21, _x22, _x23, _x24, _x25) {
        return _mintasset.apply(this, arguments);
      }

      return mintasset;
    }()
  }, {
    key: "setassetdata",
    value: function () {
      var _setassetdata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(authorization, authorized_editor, owner, asset_id, mutable_data) {
        var asset, mutable_attribute_map;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.api.getAsset(asset_id);

              case 2:
                asset = _context4.sent;
                mutable_attribute_map = Generator_1.toAttributeMap(mutable_data, asset.schema.format);
                return _context4.abrupt("return", _get(_getPrototypeOf(ExplorerActionGenerator.prototype), "setassetdata", this).call(this, authorization, authorized_editor, owner, asset_id, mutable_attribute_map));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setassetdata(_x26, _x27, _x28, _x29, _x30) {
        return _setassetdata.apply(this, arguments);
      }

      return setassetdata;
    }()
  }, {
    key: "setcoldata",
    value: function () {
      var _setcoldata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(authorization, collection_name, data) {
        var mdata;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = Generator_1;
                _context5.t1 = data;
                _context5.next = 4;
                return this.config;

              case 4:
                _context5.t2 = _context5.sent.collection_format;
                mdata = _context5.t0.toAttributeMap.call(_context5.t0, _context5.t1, _context5.t2);
                return _context5.abrupt("return", _get(_getPrototypeOf(ExplorerActionGenerator.prototype), "setcoldata", this).call(this, authorization, collection_name, mdata));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setcoldata(_x31, _x32, _x33) {
        return _setcoldata.apply(this, arguments);
      }

      return setcoldata;
    }()
  }]);

  return ExplorerActionGenerator;
}(Generator_1.ActionGenerator);

exports.default = ExplorerActionGenerator;